import { state } from '@/store/autoSubscribe/state';
import { actions } from '@/store/autoSubscribe/actions';
import { mutations } from '@/store/autoSubscribe/mutations';
import { getters } from '@/store/autoSubscribe/getters';

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export { state, getters, mutations, actions };
